import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Notices from "@/components/Notices";
import Process from "@/components/Process";
import Coverage from "@/components/Coverage";
import Governance from "@/components/Governance";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";
import AdminPage from "@/components/AdminPage";
import VendorRegister from "@/components/VendorRegister";
import VendorDesk from "@/components/VendorDesk";

const Landing = () => (
  <div className="bg-night text-ink font-sans antialiased min-h-screen selection:bg-brand selection:text-night">
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Notices />
      <Process />
      <Coverage />
      <Governance />
      <EnquiryForm />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/register" element={<VendorRegister />} />
          <Route path="/vendor" element={<VendorDesk />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
